import { TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoiceSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

/** The company that issued the invoice, as printed on it. */
export function IncomingInvoiceFormIssuer() {
	/** Context */
	const methods = useFormContext<IncomingInvoiceSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const field = (name: keyof IncomingInvoiceSchema, label: string, className?: string) => (
		<div className={className}>
			<TextInput
				control={methods.control}
				name={name}
				label={label}
				isRequired={false}
			/>
		</div>
	);

	/** Render */
	return (
		<div className="v-stack gap-4">
			<p className="label">{t("incoming_invoices.issuer")}</p>
			{field("issuerName", t("incoming_invoices.issuer_name"))}
			<div className="grid grid-cols-4 gap-4">
				{field("issuerStreet", t("address.street"), "col-span-3")}
				{field("issuerHouseNumber", t("address.house_number"))}
				{field("issuerZipCode", t("address.zip_code"))}
				{field("issuerCity", t("address.city"), "col-span-2")}
				{field("issuerCountry", t("address.country"))}
			</div>
			<div className="grid grid-cols-2 gap-4">
				{field("issuerVatId", t("incoming_invoices.vat_id"))}
				{field("issuerTaxNumber", t("incoming_invoices.tax_number"))}
				{field("issuerEmail", t("personnel.fields.email"))}
				{field("issuerPhone", t("personnel.fields.phone"))}
			</div>
		</div>
	);
}
